import { useCallback } from "react";

import { FeatureIslandHeader } from "@/components/features/_layouts";

import { Button } from "@/components/ui/button/button";

export const HeaderComposition = () => {
	/**
	 * 印刷
	 */
	const handleClickPrint = useCallback(() => {
		window.print();
	}, []);

	return (
		<FeatureIslandHeader
			title="予約詳細"
			rightChildren={
				<Button variant="outline" type="button" onClick={handleClickPrint}>
					印刷
				</Button>
			}
		/>
	);
};
